import { render, staticRenderFns } from "./permissionpackagelist.vue?vue&type=template&id=56b6775d&"
import script from "./permissionpackagelist.vue?vue&type=script&lang=js&"
export * from "./permissionpackagelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports